import { createContext, useContext } from "react";
import { merchantAuth } from "../services/auth";
import useSession from "../hooks/useSession";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const { user, setUser, loading, error, retry, refreshAccess } = useSession("bd_token", merchantAuth.current, { live: true });

  const login = async (email, password) => {
    const res = await merchantAuth.login(email, password);
    localStorage.setItem("bd_token", res.data.access_token);
    setUser(res.data.user);
    return res.data.user;
  };

  const registerCustomer = async (payload) => {
    const res = await merchantAuth.registerCustomer(payload);
    localStorage.setItem("bd_token", res.data.access_token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("bd_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, registerCustomer, logout, loading, error, retry, refreshAccess }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
